import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { isEqual } from 'lodash';
import axios from 'axios';
import qs from 'qs';

import Alert from '../../../components/Alert';
import Table from '../components/Table';

import { getReportsTicketsTable } from '../../../services/endpoints/reports';
import { getReportsTicketsConfigAction, setPageFiltersType, setPageFiltersQuery, setPageLoader } from '../../../redux/actions/reports';
import { reportsSelector } from '../../../redux/selectors/reports';
import { setInitPageFilters, checkInterval } from '../helpers';

let queueTimeout = null;
let cancelToken = axios.CancelToken.source();
let cancelTokenConfig = axios.CancelToken.source();
const Tickets = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const reports = useSelector((state) => reportsSelector(state));
  const { isLoading, pageFiltersQuery } = reports;

  const queryString = qs.parse(location.search.slice(1), { arrayLimit: 99999 });

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState('');

  const fetchList = async (hash) => {
    try {
      const response = await getReportsTicketsTable(hash ? { hash } : pageFiltersQuery, cancelToken.token);

      if (response.success) {
        if (response?.data?.queue?.life_time === 0) {
          clearTimeout(queueTimeout);
          setError('Request life time expired');
          dispatch(setPageLoader(false));
        }
        if (response?.data?.status === 'error') {
          clearTimeout(queueTimeout);
          setError(response?.data?.message ?? 'Something went wrong');
          dispatch(setPageLoader(false));
        }
        if (response?.data?.status === 'completed') {
          setData(response?.data);
          dispatch(setPageLoader(false));
        }
        if (response?.data?.status === 'processing') {
          queueTimeout = setTimeout(() => {
            fetchList(response?.data?.queue?.hash);
          }, checkInterval(response?.data?.queue?.request_interval));
        }
      } else {
        setError(response?.data?.message ?? 'Something went wrong');
        hash && dispatch(setPageLoader(false));
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        return;
      }
      hash && dispatch(setPageLoader(false));
      setError(error?.data?.error_message ?? 'Something went wrong');
      throw error;
    }
  };

  const getAllData = async () => {
    setError('');
    dispatch(setPageLoader(true));
    try {
      const responseConfig = await dispatch(getReportsTicketsConfigAction(pageFiltersQuery, cancelTokenConfig.token));
      if (!init) {
        dispatch(setPageFiltersType('tickets-table'));
        setInit(true);
      }
      if (responseConfig?.success) {
        if (responseConfig?.data?.queue?.enabled) {
          queueTimeout = setTimeout(() => {
            fetchList(responseConfig?.data?.queue?.hash);
          }, checkInterval(responseConfig?.data?.queue?.request_interval));
        } else {
          await fetchList();
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        return;
      }
      setError(error?.data?.error_message ?? 'Something went wrong');
      dispatch(setPageLoader(false));
    }
  };

  const cancelQueue = () => {
    clearTimeout(queueTimeout);
    cancelToken.cancel('Cancel request');
    cancelToken = axios.CancelToken.source();
    cancelTokenConfig.cancel('Cancel request');
    cancelTokenConfig = axios.CancelToken.source();
  };

  useEffect(() => {
    document.title = 'Tickets';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEqual(queryString, pageFiltersQuery)) {
      dispatch(setPageFiltersQuery(setInitPageFilters('tickets', queryString)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    cancelQueue();
    pageFiltersQuery && getAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageFiltersQuery]);

  useEffect(
    () => () => {
      dispatch(setPageFiltersType(''));
      dispatch(setPageFiltersQuery({}));
      cancelQueue();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (isLoading) return null;

  return (
    <Row>
      <Col xs={12}>
        {error ? <Alert text={error} /> : null}
        <Table data={data} />
      </Col>
    </Row>
  );
};

export default Tickets;
